import {Formik} from 'formik';
import {Button, Form} from "react-bootstrap";
import {Link} from "react-router-dom";

import AuthApi from "../api/AuthApi";
import SecurityService from '../../../services/SecurityService';
import { FormattedMessage, useIntl } from 'react-intl';


export default function LoginForm(props) {
    const intl = useIntl();
    
    const authenticate = (username, password) => {
        return AuthApi.login(username, password)
            .then((data) => {
                console.log(data)
                SecurityService.setAccessToken(data.accessToken)
                 // navigate("/");
                window.location.href = "/dashboard";
                window.location.reload();
            })
    }
    return (
        <>
            <div className="peers ai-s fxw-nw h-100vh">
            <div className="login-bg d-n@sm- peer peer-greed h-100 pos-r bgr-n bgpX-c bgpY-c bgsz-cv">
                {/* <div className="pos-a centerXY">
                <div className="bgc-white bdrs-50p pos-r" style="width: 120px; height: 120px;">
                    <img className="pos-a centerXY" src="assets/static/images/logo.png" alt=""/>
                </div>
                </div> */}
            </div>
            <div className="col-12 col-md-4 peer pX-40 pY-80 h-100 bgc-white scrollable pos-r" >
                <h4 className="fw-300 c-grey-900 mB-40">
                   <FormattedMessage id="sign_in"/>
                </h4>
                
                <Formik
                initialValues={{ username: '', password: '' }}
                validate={values => {
                    const errors = {};
                    if (!values.username) {
                        errors.username = intl.formatMessage({id:"field_required"});;
                    }
                    if (!values.password) {
                        errors.username = intl.formatMessage({id:"field_required"});;
                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    authenticate(values.username, values.password)
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                  }) => (

                    <Form onSubmit={handleSubmit} noValidate={true}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>
                                <FormattedMessage id="username"/>
                            </Form.Label>
                            <Form.Control type="text" placeholder="Username"
                                          name="username"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.username}/>

                            {errors.username && touched.username && <Form.Text className="text-danger">
                                {errors.username}
                            </Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>
                                <FormattedMessage id="password"/>
                            </Form.Label>
                            <Form.Control type="password"
                                          name="password"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.password}
                                          placeholder="Password" />
                            {errors.password && touched.password && <Form.Text className="text-danger">
                                {errors.password}              
                            </Form.Text>}
                        </Form.Group>
                        {/*<Form.Group className="mb-3" controlId="formBasicCheckbox">*/}
                        {/*    <Form.Check type="checkbox" label="Check me out" />*/}
                        {/*</Form.Group>*/}
                        {/*disabled={isSubmitting}*/}
                        <Button variant="primary" type="submit" >
                            <FormattedMessage id="sign_in"/>
                        </Button>
                    </Form>
                )}
            </Formik>
            <div>
                <Link to={"/register"}>
                    <FormattedMessage id="registration"/>
                </Link>
            </div>

            </div>
            </div>
        </>
    )
}